import { ToasterComponent } from '../../../toasterComponent/toasterComponent';
import { Component, ViewContainerRef } from '@angular/core';
import { MDMService } from '../services/mdmService.service';
import * as _ from 'underscore';
import { BiUrls } from '../../biUrls';

@Component({
    selector: 'dimension',
    templateUrl: 'dimension.component.html'
})

export class DimensionComponent {

    public dimRegex: string = '';
    public selectedDimId: number;
    public searchButton: boolean = false;
    public mainPage: boolean = true;
    public dimensionPage: boolean = false;
    public dimensionList: any = [];
    public saveButton: boolean = false;
    public accessDenied: boolean = false;
    public dataSourceList: any = [];
    public isEdit: boolean = false;
    public dimHierarchyLevelData: any = [];
    public isDimTime: boolean = false;
    public recordFormatList: any = [];
    public selectedRFF: any;
    public loader: boolean = false;
    public levelError: any = '';
    public dimensionData: any = {
        id: null, name: '', description: null, dimTime: null, deleted: 0, dimHierarchyData: []
    };
    public dimHierarchyDataObject: any = { id: null, name: '', dimHierarchLevelData: [] };
    public dimHierarchyLevelDataObject: any = {
        id: null, displayName: '', levelNumber: null, levelType: 'selectOne'
    };
    public pageNo: number = 0;
    public currentPage: number = 1;
    public startingPage: number = 0;
    public pageSize: number = 10;
    public endingPage: number = 0;
    public totalDimensions: number = 0;
    public totalPages: number = 0;
    public lastRegex: string = '';
    public sPage: number = 0;

    constructor(
        public dimesionService: MDMService,
        public toaster: ToasterComponent,
        public vcr: ViewContainerRef) {
        this.toaster.setViewRef(vcr);
    }

    public ngOnInit() {
        if (this.dimesionService.isBIAdmin) {
            this.loadDimensions();
        } else {
            this.accessDenied = true;
        }
    }

    public entityOps(event) {
        if (this.selectedDimId == null) {
            this.selectedDimId = event.target.id;
        } else {
            this.selectedDimId = null;
        }
    }

    public closeDropDown(event){
        this.selectedDimId = null;
    }

    public onPageChange(event: number): void {
        this.currentPage = event;
        this.pageNo = this.currentPage - 1;
        if (this.dimRegex != '') {
            this.searchPDim();
        } else {
            this.loadDimensions();
        }
        this.setEndingPage(this.totalDimensions);
    }

    public setEndingPage(total) {
        let self = this;
        if (self.currentPage == 1) {
            self.startingPage = 0;
            if (total > self.pageSize) {
                self.endingPage = self.pageSize;
            } else {
                self.endingPage = total;
            }
        } else {
            self.startingPage = 0 + ((self.currentPage - 1) * + self.pageSize);
            self.endingPage = +self.pageSize + ((self.currentPage - 1) * +self.pageSize);
            if (self.endingPage > total) {
                self.endingPage = total;
            }
        }
    }

    public OnPageSizeChanged(event) {
        this.pageSize = event.target.value;
        let maxPage = Math.floor(this.totalDimensions / this.pageSize);
        if (maxPage < this.pageNo || maxPage < this.sPage) {
            this.pageNo = maxPage;
            this.sPage = this.pageNo;
        }
        this.loadDimensions();
    }

    public loadDimensions() {
        return new Promise((resolve) => {
            let self = this;
            self.loader = true;
            this.dimesionService.getDataByPage(BiUrls.DIMENSION, self.pageNo,
                self.pageSize).then((res) => {
                    self.dimensionList = [];
                    self.totalDimensions = 0;
                    self.totalPages = 0;
                    if (res != undefined) {
                        self.dimensionList = res.data != undefined &&
                            res.data.pageElements != undefined ? res.data.pageElements :
                            self.toaster.showError('No results found');
                        self.totalDimensions = res.data != undefined &&
                            res.data.total != undefined ? res.data.total : 0;
                    }
                    self.setEndingPage(self.totalDimensions);
                    self.loader = false;
                    self.mainPage = true;
                    resolve('completed');
                }, (err) => {
                    console.error(err);
                });
        });
    }

    //ByLalu
    public searchPDim() {
        return new Promise((resolve) => {
            let self = this;
            self.mainPage = true;
            self.loader = true;
            self.dimensionList = [];
            if (self.dimRegex != self.lastRegex) {
                self.sPage = 0;
                self.currentPage = 1;
            } else {
                self.sPage = self.currentPage - 1;
            }
            self.lastRegex = self.dimRegex;
            self.dimesionService.search(BiUrls.DIMENSION, BiUrls.SEARCH_P_DIMENSION,
                self.dimRegex, self.sPage, self.pageSize).then((res) => {
                    self.loadSearchedPDimension(res);
                    self.loader = false;
                }, (err) => {
                    console.error(err);
                });
            resolve('completed');
        });
    }

    //ByLalu
    public loadSearchedPDimension(res) {
        let self = this;
        self.dimensionList = (res != undefined) ? res.data.pageElements : [];
        self.totalDimensions = (res != undefined) ? res.data.total : 0;
        self.setEndingPage(self.totalDimensions);
    }

    public loadRecordFormat() {
        return new Promise((resolve) => {
            let self = this;
            this.dimesionService.onStartUp(BiUrls.RECORDFORMAT).then((res) => {
                self.recordFormatList = res != undefined && res.data != undefined ? res.data : [];
            }, (err) => {
                console.error(err);
            });
            resolve('completed');
        });
    }

    public addNewDimension() {
        this.mainPage = false;
        this.dimensionPage = true;
        this.dimensionData = {
            id: null, name: '', description: '', dimTime: false, deleted: 0,
            dimHierarchyData: []
        };
        this.dimHierarchyDataObject = { id: null, name: '', dimHierarchyLevelData: [], deleted: 0 };
        this.isDimTime = null;
    }

    public loadAfterSaveOrEdit(result, type) {
        let self = this;
        self.toaster.setViewRef(this.vcr);
        self.totalPages = Math.floor(self.totalDimensions / self.pageSize);
        self.pageNo = self.isEdit == true ? self.pageNo : self.totalPages;
        let text = type == 'new' ? 'Dimension added successfully' : 'Changes saved successfully';
        if (self.dimRegex != '') {
            self.searchPDim().then(res => {
                self.setPageFieldsAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toaster.showSuccess(text);
                } else {
                    self.toaster.showError(result.statusText);
                }
            });

        } else {
            self.loadDimensions().then((res) => {
                self.setPageFieldsAfterLoading();
                if (result.error == undefined && result.success == true) {
                    self.toaster.showSuccess(text);
                } else {
                    self.toaster.showError(result.statusText);
                }
            });
        }
        self.currentPage = self.pageNo + 1;
    }

    public setPageFieldsAfterLoading() {
        let self = this;
        self.saveButton = false;
        self.mainPage = true;
        self.dimensionPage = false;
        self.isEdit = false;
        self.selectedRFF = null;
        self.dimHierarchyLevelData = [];
    }

    public editDimension(dimension) {
        let self = this;
        self.dimensionData = dimension;
        self.selectedDimId = null;
        self.isEdit = true;
        self.mainPage = false;
        self.dimensionPage = true;
    }

    public removeDimension(dimension) {
        let r = confirm('Are you sure you want to remove the dimension ' + dimension.name + ' ?');
        if (r == true) {
            this.delete(dimension);
        }
    }

    public delete(dimension) {
        let self = this;
        self.loader = true;
        self.dimesionService.delete(BiUrls.DIMENSION, dimension.id).then((response) => {
            if (response == undefined || response.data == undefined) {
                self.toaster.showError('Unable to remove Dimenison');
            } else {
                self.pageNo = self.dimensionList.length == 1 ?
                    self.totalDimensions == 1 ? 0 : --self.pageNo : self.pageNo;
                self.loadDimensions();
                self.loader = false;
                self.toaster.showSuccess(dimension.name + ' removed successfully');
            }
        }, (error) => {
            console.error(error);
        });
    }

    public onBack() {
        this.mainPage = true;
        this.dimensionPage = false;
        this.selectedDimId = null;
        this.isEdit = false;
        this.dimHierarchyLevelData = [];
        this.dimensionData = {};
        this.dimHierarchyDataObject = {};
        this.selectedRFF = null;
    }

}



// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/dimension.component.ts